import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";

export const NumberOfLineItemsCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  { header: "Unique product count", cell: (row) => String(row.totalSkuCount) };
